<div class="tab-selector-container">
  <div *ngFor="let tab of tabOptions">
    <a class="tab-selector-option" id="tab_{{tab.id}}" [routerLink]="tab.link"
      [ngClass]="{'selected-tab': isActiveTab(tab.id)}" (click)="onTabSelect(tab.id)"
      [attr.aria-current]="isActiveTab(tab.id) ? 'page' : null" role="button">
      {{ tab.displayName }}
    </a>
  </div>
</div>